import { string_to_span } from '@/utils/utils_html';
import { ENUM__position_9, ENUM_UTILS__position_9 } from '@shared/enums/ENUM__position_9';

interface PROPS {
  text?: string;
  position: ENUM__position_9;
}

export function LABEL__image_info({ text = '', position }: PROPS) {
  if (text == '') return null;

  return (
    <div
      className={`absolute ${ENUM_UTILS__position_9.to_css_1(position)} z-[10] flex items-center gap-2 px-1 py-0.5
        
      bg-black/60 rounded-sm text-[0.5rem] text-gray-300 pointer-events-none  truncate`}
    >
      {string_to_span(text)}
    </div>
  );
}
